// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__1MKOy","label":"Completed_label__2e5j-"};